import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import { AgencyModel, BrandThemeModel, ProviderModel, PublicationModel, ServiceProductModel, TemplateGroupModel } from '@domain-group/realhub-backend-api-types'

type ServiceProductProps = {
  callbacks?: {
    onClick: () => void,
  },
  entity: AgencyModel
    | BrandThemeModel
    | ProviderModel
    | PublicationModel
    | ServiceProductModel
    | TemplateGroupModel,
  selected: boolean,
}

const ServiceProduct = (props: ServiceProductProps) => {
  const {
    callbacks,
    entity: { id, title },
    selected,
  } = props

  const { onClick } = callbacks || {}

  return (
    <DashboardModuleListItem
      isChecked={selected}
      onClick={onClick}
      showCheckbox
      title={title}
    >
      <Text color="bodyFontLightColor">ID #{id}</Text>
    </DashboardModuleListItem>
  )
}

export default ServiceProduct
